import * as React from "react";

function SvgPlay(props) {
  return (
    <svg 
      height=".7em" 
      viewBox="-45 0 327 327" 
      width=".7em" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
        <path d="m158 0h71c4.417969 0 8 3.582031 8 8v311c0 4.417969-3.582031 8-8 8h-71c-4.417969 0-8-3.582031-8-8v-311c0-4.417969 3.582031-8 8-8zm0 0"/><path d="m8 0h71c4.417969 0 8 3.582031 8 8v311c0 4.417969-3.582031 8-8 8h-71c-4.417969 0-8-3.582031-8-8v-311c0-4.417969 3.582031-8 8-8zm0 0"/>
    </svg>
  );
}

export default SvgPlay;
